var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"welcome","src":require("../../assets/image/welcome.png")}}),_c('div',[_vm._v(" 你好，欢迎使用")])])
}]

export { render, staticRenderFns }